import { useState } from "react";
import EnsoStatus from "./components/ensoStatus/ensoStatus";
import PowerRank from "./components/powerRank/powerRank";
import RenewMap from "./components/renewMap/renewMap";
import RenewStatus from "./components/renewStatus/renewStatus";
import { useRenewData } from "./hooks/useRenewData";
import styles from "./renewStat.module.scss";
import Overlay from "./components/overlay/overlay";
import GuideBlock from "./components/guideBlock/guideBlock";
import { Append } from "./components/append/append";

export default function RenewStat({ conn }) {
	const [rgnCode, setRgnCode] = useState('');
	const [bizType, setBizType] = useState('bpm');
	const data = useRenewData({ conn, rgnCode, bizType });
	return (
		<div className={styles.wrapper} style={{ backgroundImage: `url("/images/renewStat/bg.png"`, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
			<div className={styles.template}>		
				<section>
					<div className={styles.title}>
						<div>충청남도</div>
						<div>신재생에너지 현황</div>
					</div>
					<RenewStatus
						top3EnsoStatDtoList={data.top3EnsoStatDtoList}
						dashboardList={data.dashboardList}
						previousMonthCount={data.previousMonthCount}
						rgnCode={rgnCode}
						bizType={bizType}
					/>
					<PowerRank data={data.monthDashboardList}/>
				</section>

				<section className={styles['map-container']}>
					<div className={styles.map}>
						<RenewMap
							data={data.dashboardList}
							rgnCode={rgnCode}
							onClick={(value) => setRgnCode((prev) => prev === value ? '' : value)}
						/>
						<Overlay data={data.dashboardList} rgnCode={rgnCode}/>						
					</div>
				</section>

				<section className={styles.section}>
					<Append onChangeBizType={setBizType}/>
					<EnsoStatus data={data.top3EnsoStatDtoList} bizType={bizType}/>
					<GuideBlock />
				</section>
			</div>
		</div>
	);		
}